import { HEAD_YAW_THRESHOLD } from '../constants';
import type { FrameResult } from '../types';
import { BaseChallenge } from './base-challenge';

export class HeadTurnLeftChallenge extends BaseChallenge {
  constructor() {
    super('head_turn_left');
  }

  processFrame(frame: FrameResult): void {
    if (!frame.headPose) {
      return;
    }

    this.captureFrame();

    const { yaw } = frame.headPose;

    const progress = Math.max(Math.min(yaw / HEAD_YAW_THRESHOLD, 1), 0);
    this.reportProgress(progress);

    if (yaw > HEAD_YAW_THRESHOLD) {
      this.pass(0.9);
    }
  }
}
